module.exports = __webpack_public_path__ + "static/media/flowers2.c489f23a.gif";